import React from "react"
import Layout from "../components/sharedLayout"
import SEO from "../components/seo"
import { Container, Row, Col } from "react-bootstrap"

const ErrorOccurred = () => (
  <Layout>
    <SEO title="Windscreen Claim" />
    <Container className="body-content mt-md-4">
      <Col xs={12}>
        <Row className={"MarginTop75 "}>
          {/* <h1>Page Not Found</h1> */}

          <Col xs={12} className="submittedContainerBody marginTop3x">
            <Col xs={12} md={12}>
              <div className="title text-center">
                We are having difficulties processing your eClaim.
              </div>
              <Col md={12}>
                <label className="receiveClaimLabel mt-3">
                  Please contact our Customer Care Consultants for assistance.
                </label>

                <Col xs={12} md={12} className="text-center">
                  <p className="mt-4">
                    <span className="customerCareTitle">
                      Customer Care operating hours:
                    </span>{" "}
                    <span className="customerCareText1">
                      Monday to Friday, 8:45am to 5:30pm, excluding saturday,
                      sunday and public holidays
                    </span>
                  </p>
                  <p>
                    <span className="customerCareTitle">
                      <span className="fa fa-envelope-o"></span> Email:
                    </span>{" "}
                    <span className="customerCareText2">
                      <a href="mailto:customer.service@etiqa.com.sg">
                        <u>customer.service@etiqa.com.sg</u>
                      </a>
                    </span>
                  </p>
                  <p className="mb-4">
                    <span className="customerCareTitle">
                      <span className="fa fa-whatsapp"></span> Whatsapp:
                    </span>{" "}
                    <span className="customerCareText2">+65 68878777</span>
                  </p>
                </Col>
              </Col>
            </Col>
          </Col>
          <Col xs={12} className="submittedContainerBody marginTop3x"></Col>
        </Row>
      </Col>
    </Container>
  </Layout>
)

export default ErrorOccurred
